var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"pageTitle-area"}},[(_vm.backBtn)?_c('div',{staticClass:"back",on:{"click":_vm.back}},[_vm._v("戻る")]):_vm._e(),_c('div',{attrs:{"id":"pageTitle"}},[_vm._v(_vm._s(_vm.txt))])])}
var staticRenderFns = []

export { render, staticRenderFns }